<template>
  <div class="grid-x phila-header align-middle header-background">
    <div class="cell large-12 small-24 large-order-1 small-order-2">
      <div class="header-text">
        <span class="new-header-text">{{ $t("welcome.one-philly") }}</span><br>
        <span class="new-header-text">{{ $t("welcome.united-city") }}</span>
      </div>
    </div>
    <div class="cell large-12 small-24 large-order-2 small-order-1">
      <div class="header-images">
        <img
          v-for="(image, index) in topImages"
          :key="index"
          :src="image"
          :class="{ heroShow: currentTopImageIndex === index, heroHide: currentTopImageIndex !== index }"
          class="header-image-1"
          alt=""
        >
        <img
          v-for="(image, index) in centerImages"
          :key="'a' + index"
          :src="image"
          :class="{ heroShow: currentCenterImageIndex === index, heroHide: currentCenterImageIndex !== index }"
          class="header-image-2"
          alt=""
        >
        <img
          v-for="(image, index) in bottomImages"
          :key="'b' + index"
          :src="image"
          :class="{ heroShow: currentBottomImageIndex === index, heroHide: currentBottomImageIndex !== index }"
          class="header-image-3"
          alt=""
        >
      </div>
    </div>
    <div class="slideshow-controls">
      <button @click="toggleSlideshow">
        <i
          v-if="isPlaying"
          class="fa-solid fa-pause"
        ><span class="show-for-sr">Pause</span></i>
        <i
          v-else
          class="fa-solid fa-play"
        ><span class="show-for-sr">Play</span></i>
      </button>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      topImages: [
        "https://www.phila.gov/assets/images/website/header/top1.png",
        "https://www.phila.gov/assets/images/website/header/top2.png",
        "https://www.phila.gov/assets/images/website/header/top3.png",
      ],
      centerImages: [
        "https://www.phila.gov/assets/images/website/header/center1.png",
        "https://www.phila.gov/assets/images/website/header/center2.png",
        "https://www.phila.gov/assets/images/website/header/center3.png",
      ],
      bottomImages: [
        "https://www.phila.gov/assets/images/website/header/bottom1.png",
        "https://www.phila.gov/assets/images/website/header/bottom2.png",
        "https://www.phila.gov/assets/images/website/header/bottom3.png",
      ],
      currentTopImageIndex: 0,
      currentCenterImageIndex: 0,
      currentBottomImageIndex: 0,
      isPlaying: true,
      slideshowInterval: null,
    };
  },
  computed: {
    currentTopImage() {
      return this.topImages[this.currentTopImageIndex];
    },
    currentCenterImage() {
      return this.centerImages[this.currentCenterImageIndex];
    },
    currentBottomImage() {
      return this.bottomImages[this.currentBottomImageIndex];
    },

  },
  mounted: async function () {
    this.startImageSlideshow();
  },
  beforeDestroy() {
    this.stopImageSlideshow();
  },
  methods: {
    startImageSlideshow() {
      this.slideshowInterval = setInterval(() => {
        this.currentTopImageIndex = (this.currentTopImageIndex + 1) % this.topImages.length;
        this.currentCenterImageIndex = (this.currentCenterImageIndex + 1) % this.centerImages.length;
        this.currentBottomImageIndex = (this.currentBottomImageIndex + 1) % this.bottomImages.length;
      }, 5000);
    },
    stopImageSlideshow() {
      clearInterval(this.slideshowInterval);
      this.slideshowInterval = null;
    },
    toggleSlideshow() {
      this.isPlaying = !this.isPlaying;
      if (this.isPlaying) {
        this.startImageSlideshow();
      } else {
        this.stopImageSlideshow();
      }
    },
  },
};
</script>
<style lang="scss" scoped>

.header-background {
  background-image: url("https://www.phila.gov/assets/images/website/header-bg.png");
  background-position: center top;
  background-size: 100% 100vh;
  height:100vh;
  background-repeat: no-repeat;
  @media (max-width: 768px) {
    background-size: 150% 75vh;
    background-position: center top;
    height: 75vh;
  }

}

img.heroShow {
  opacity: 1;
  transition: opacity 1s ease-in-out;
}

img.heroHide {
  opacity: 0;
  transition: opacity 5s  ease-in-out;
}
</style>